var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-cover"},[_c('sep',{attrs:{"name":"XL"}}),_c('main-container',{staticClass:"title"},[_c('typo',{attrs:{"name":"title-30-bold"}},[_vm._v(_vm._s(_vm.title))]),_c('typo',{attrs:{"name":"title-24-bold"}},[_vm._v(_vm._s(_vm.subtitle))])],1),_c('img',{attrs:{"src":_vm.cover}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }